import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const Loader = ({ message }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    //   minHeight="100vh"
    >
      <CircularProgress 
        size="5vh"
        sx={{ 
          width: '5vh !important', 
          height: '5vh !important',
          '& svg': {
            width: '5vh',
            height: '5vh'
          }
        }} 
      />
      <Typography 
        sx={{ 
          marginTop: '1.6vh', 
          color: 'white !important', 
          fontSize: '2vh !important',
          letterSpacing: '0.064vh !important',
          fontWeight: '100 !important',
          lineHeight: 'normal !important'
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default Loader;
